import { FormFieldsGeneratorService } from './../form-helpers/form-fields-generator.service';
import { FormFieldComponent } from './../form-helpers/form-field/form-field.component';
import { IConfig } from './../../interfaces/config.interface';
import { Component, ElementRef, QueryList, Renderer2, ViewChild, ViewChildren } from '@angular/core';
import { FormFieldsMasks } from '../field-mask/form-fields-masks';
import { FormStateChange, FormStateChangeService, StateInputFields } from '../form-state/form-state-change.service';
import { CommonInfoService } from '../../cart-process/common-info.service';
import B2bB2cFormSwitcherService from './b2b-b2c-form-switcher.service';
import {
  NotificationProviderService,
  NotificationProviderTypeEnum
} from '../../external-interfaces/notification-provider.service';
import { CustomerDetailsModel } from '../../models/customer-details.model';
import { slideInOut } from '../../utils/animations/slides.animation';
import { DeliveryFormOutputState, DeliveryFormStateService } from '../form-state/delivery-form-state.service';
import { FormGroup } from '@angular/forms';
import { UserDataFormService } from './user-data-form.service';
import CustomerDetailsService from '../../cart-process/customer-details.service';
import { IdTypeEnum } from '../../models/cartDetails/idType.enum';
import { CommonModalTemplatesEnum } from '../../utils/modals/common-modal-templates.enum';
import { CommonModalService } from '../../utils/modals/common-modal.service';

@Component({
  selector: 'user-data-form-component',
  templateUrl: './user-data-form.component.html',
  animations: [slideInOut],
  providers: [
    UserDataFormService
  ]
})
export class UserDataFormComponent {

  public userDetails: CustomerDetailsModel;
  public idTypeEnum = IdTypeEnum;
  public idType: IdTypeEnum;
  public isB2BOffer = false;
  public isVirginBrand = false;
  public formFields: any;
  public isCorrespondenceAddressFormHidden: boolean;
  public enableMIdCard: boolean;
  private lastIdExpiryDateValue: string;
  public showCalendar = false;
  public activeForm: FormGroup;

  @ViewChild('idExpiryDate') idExpiryDate: ElementRef<HTMLElement>;
  @ViewChildren('calendarElement') calendarElements: QueryList<FormFieldComponent>;

  constructor(
    public validationMasks: FormFieldsMasks,
    public switcher: B2bB2cFormSwitcherService,
    private formStateChangeService: FormStateChangeService,
    private notificationProvider: NotificationProviderService,
    protected commonInfo: CommonInfoService,
    private deliveryFormState: DeliveryFormStateService,
    public userDataFormService: UserDataFormService,
    private customerDetailsService: CustomerDetailsService,
    private renderer: Renderer2,
    private commonModalService: CommonModalService,
    private formsGenerator: FormFieldsGeneratorService

) {
    this.formsGenerator.watchUserData();
    this.idType = IdTypeEnum.ID_CARD;
    this.formFields = this.userDataFormService.formFields;


    this.isCorrespondenceAddressFormHidden = deliveryFormState.outputState.isCorrespondenceAddressFormHidden;

    this.deliveryFormState.subscribe(
      (deliveryFormOutputState: DeliveryFormOutputState) => {
        this.isCorrespondenceAddressFormHidden = deliveryFormOutputState.isCorrespondenceAddressFormHidden;
     });


    this.formsGenerator.watchActiveForm().subscribe(form => {
      this.activeForm = form;

      if (this.activeForm?.get('mailingAddressOption')) {
        this.isCorrespondenceAddressFormHidden = this.activeForm?.get('mailingAddressOption')?.value === 'off';

        this.formStateChangeService.setField(
          new FormStateChange(
            StateInputFields.CORRESPONDENCE_OTHER_ADDRESS_CHECKBOX,
            !this.isCorrespondenceAddressFormHidden
          )
        );
      }
    });

    this.notificationProvider.subscribe(
      NotificationProviderTypeEnum.CUSTOMER_DETAILS,
      (customerData: CustomerDetailsModel) => {
        if (!customerData) {
          return;
        }

        this.userDetails = customerData;
      }
    );

    this.notificationProvider.subscribe(
      NotificationProviderTypeEnum.CONFIG,
      (config: IConfig) => {
        if (config) {
          this.enableMIdCard = config.enableMIdCard;
        }
      }
    );

    this.notificationProvider.subscribe(
      NotificationProviderTypeEnum.COMMON_INFO,
      (commonInfo: CommonInfoService) => {
        if (commonInfo) {
          this.isB2BOffer = !commonInfo.b2c;
          this.isVirginBrand = commonInfo.isVirginBrand;

          this.formsGenerator.setSecondStepActiveForm(commonInfo.b2c);
          this.changeIdType(this.idType);
        }
      }
    );
  }

  public getClassNames() {
    return {
      'form-with-switcher': this.switcher.showSwitcher,
      'form-activation': !(this.customerDetailsService.ifCustomerDataExist && this.commonInfo.isMigrationOffer),
      'form-with-data': this.customerDetailsService.ifCustomerDataExist
    };
  }

  public onOtherCorrespondenceAddressClick(checked: boolean): void {
    // na potrzeby autouzupełniaczki
    if (this.formFields['correspondenceAddress']) {
      this.setOtherCorrespondenceAddressValidity(checked);
    }

    this.formStateChangeService.setField(
      new FormStateChange(
        StateInputFields.CORRESPONDENCE_OTHER_ADDRESS_CHECKBOX,
        checked
      )
    );
  }

  public setOtherCorrespondenceAddressValidity(shouldShow: boolean): void {
    this.formsGenerator.toggleExpandedFormGroupVisibility('correspondenceAddress', this.activeForm, !shouldShow, shouldShow);
  }

  public onIndefiniteIdClick($event: any): void {
    const idExpiryDateField = this.activeForm.controls.customerDetails.get('idExpiryDate');

    if ($event.target.checked) {
      this.lastIdExpiryDateValue = idExpiryDateField.value;
      idExpiryDateField.setValue('31.12.2999');
      this.renderer.setStyle(this.idExpiryDate.nativeElement, 'display', 'none');
    } else {
      this.renderer.setStyle(this.idExpiryDate.nativeElement, 'display', 'block');
      idExpiryDateField.setValue(this.lastIdExpiryDateValue);
    }
    idExpiryDateField.updateValueAndValidity();
  }

  protected checkIndefiniteId(): boolean {
    const idExpiryDateField = this.activeForm.controls.customerDetails.get('idExpiryDate');

    return idExpiryDateField?.value === '31.12.2999';
  }

  public openUserWithoutIDModal(event: Event): void {
    event.preventDefault();
    // TODO: Creating and opening a modal for a user without an ID card
  }

  public openModal(event: Event): void {
    event.preventDefault();

    const modalData = {
      templateName: CommonModalTemplatesEnum.SHOW_MORE_ID_TYPE_INFORMATION,
    };

    this.commonModalService.setData(modalData);
  }

  public changeIdType(idType: IdTypeEnum): void {
    this.idType = idType;

    if (this.formFields['id-number']) {
      this.activeForm.get('idCardType').setValue(idType);
      this.formsGenerator.updateFormByIdType(idType);
    } else {
      this.activeForm.removeControl('idCardType');
    }
  }

  protected closeCalendar(): void {
    this.calendarElements.forEach(item => item.onCloseCalendar());
  }
}
